var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrap"},[_c('LandingScreen',{attrs:{"bgImg":_vm.bgImg,"screenId":_vm.screenId}}),_c('HomeScreenInfo'),_c('HomeCategories'),_c('div',{staticClass:"anim-leave"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }